module.exports = __webpack_public_path__ + "static/media/file-archive.f7b7246e.svg";